export default {"src":"/_next/static/media/Banner-logo.2824e547.svg","height":236,"width":536};